import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import OfferPagePromoLinks from './OfferPagePromoLinks/OfferPagePromoLinks.container';
import OfferPagePromoBanners from './OfferPagePromoBanners/OfferPagePromoBanners.container';
import OfferPagePromoContainers from './OfferPagePromoContainers/OfferPagePromoContainers.container';
import OfferPagePromoLandings from './OfferPagePromoLandings/OfferPagePromoLandings.container';
import { I18nContext } from 'utils/I18n/context';

const startTab = 'links';

const OfferPagePromo = ({ 
    location, 
    showConstructor, 
    showConstructorPromoCode, 
    showConstructorPromoCodeList 
}) => {
    const { t } = useContext(I18nContext);

    const getClassActivePanel = useCallback((event) => {
        let target = event.target;
        let button = null === target.querySelector('.tab-icon') ? event.target : target.querySelector('.tab-icon');
        let content = target.closest('.offer-item__promo-block').querySelector('.ibox');

        button.classList.toggle('fa-chevron-down');
        button.classList.toggle('fa-chevron-up');
        content.classList.toggle('hidden');
    }, []);

    const staticNames = t?.offersPage?.offer || {};

    return (
        <div className="offer-item__promo">
            <div className="offer-item__promo-block links-block">
                <div className="links-block__tab tab chevron-icon" onClick={getClassActivePanel}>
                    <span>{staticNames.links}</span>
                    <span className="tab-icon fa fa-chevron-down"></span>
                </div>
                <OfferPagePromoLinks 
                    showConstructor={showConstructor}
                    showConstructorPromoCode={showConstructorPromoCode}
                    showConstructorPromoCodeList={showConstructorPromoCodeList}
                />
            </div>
            <div className="offer-item__promo-block  banners-block">
                <div className="banners-block__tab tab chevron-icon" onClick={getClassActivePanel}>
                    <span>{staticNames.banners}</span>
                    <span className="tab-icon fa fa-chevron-up"></span>
                </div>
                <OfferPagePromoBanners 
                    showConstructor={showConstructor}
                    showConstructorPromoCode={showConstructorPromoCode}
                    showConstructorPromoCodeList={showConstructorPromoCodeList}
                />
            </div>
            <div className="offer-item__promo-block containers-block">
                <div className="containers-block__tab tab chevron-icon" onClick={getClassActivePanel}>
                    <span>{staticNames.containers}</span>
                    <span className="tab-icon fa fa-chevron-up"></span>
                </div>
                <OfferPagePromoContainers 
                    showConstructor={showConstructor}
                    showConstructorPromoCode={showConstructorPromoCode}
                    showConstructorPromoCodeList={showConstructorPromoCodeList}
                />
            </div>
            <div className="offer-item__promo-block landings-block">
                <div className="landings-block__tab tab chevron-icon" onClick={getClassActivePanel}>
                    <span>{staticNames.landings}</span>
                    <span className="tab-icon fa fa-chevron-up"></span>
                </div>
                <OfferPagePromoLandings 
                    showConstructor={showConstructor}
                    showConstructorPromoCode={showConstructorPromoCode}
                    showConstructorPromoCodeList={showConstructorPromoCodeList}
                />
            </div>
        </div>
    );
};

OfferPagePromo.propTypes = {
    location: PropTypes.object,
    showConstructor: PropTypes.func,
    showConstructorPromoCode: PropTypes.func,
    showConstructorPromoCodeList: PropTypes.func
};

OfferPagePromo.defaultProps = {
    location: {},
    showConstructor: () => {},
    showConstructorPromoCode: () => {},
    showConstructorPromoCodeList: () => {}
};

export default OfferPagePromo;